import React from 'react';
import {t} from '@lingui/core/macro';

import {MonitorBatchOperationsForm} from 'entities/monitor';
import {IMassOperationAction} from 'shared/ui/MassOperations/MassOperations';
import {useServerBatchOperationsForm} from 'features/server/model/useServerBatchOperationsForm';

interface IServerBatchOperationsFormProps {
    handleClose: () => void,
    action?: IMassOperationAction,
    onSuccess?: () => void,
}

const ServerBatchOperationsForm: React.FC<IServerBatchOperationsFormProps> = ({
    handleClose,
    action,
    onSuccess,
}) => {
    const state = useServerBatchOperationsForm({actionValue: action?.value, handleClose, onSuccess});

    return (
        <MonitorBatchOperationsForm
            action={action}
            state={state}
            selectedLabel={t`Выбрано серверов`}
        />
    );
};

export default ServerBatchOperationsForm;
